import React, { Component } from "react";
import {
  Text,
  View,
  TouchableOpacity,
  ActivityIndicator,
  Dimensions,
  ScrollView,
  PermissionsAndroid,
  Platform,
  TextInput,
  Modal,
  StyleSheet,
  Animated,
  Linking,
} from "react-native";
import {
  Flex,
  Padding,
  Margin,
  Helpers,
  Colors,
  FontFamily,
  FontWeight,
  button,
  modalStyle,
  Typo,
  formStyle,
  unlockBox,
} from "../../styles/appStyles";
import UploadFile from "../upload-file";
import FileCard from "../file-card";
import { helpers } from "../../utils/helpers";
import docHelpers from "../../utils/download-doc";
import ButtonGradient from "../button-gradient";
import Button from "../button";
import apiHelpers from "../../utils/api-helpers";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";

const windowHeight = Dimensions.get("window").height;

const closeIcon = getImagePath("icons/close-round.png");

const themeIconOne = getImagePath("icons/theme_icon_one.png");
const themeIconTwo = getImagePath("icons/theme_icon_two.png");
const dummyEmail = getImagePath("icons/dummyEmail.png");

const emailBanner = getImagePath("icons/giftEmailBanner.png");
const emailQuote = getImagePath("icons/emailQuote.png");
const emailQuoteSecond = getImagePath("icons/emailQuoteSecond.png");
const annualGiftSub = getImagePath("icons/annualGiftSub.png");
const creditGiftIcon = getImagePath("icons/gift_pl_one.png");
const close = getImagePath("icons/close-icon-white.png");

// import { Modal, ModalContent, SlideAnimation } from 'react-native-modals';

const maxMessageLength = 500;

class StoryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: true,
    };
  }

  componentDidMount = () => {
    document.body.style.overflow = "hidden";
  };

  setModalVisible = (isVisible) => {
    this.setState({ modalVisible: isVisible });
    document.body.style.overflow = "visible";
    this.props.closeModal();
  };

  openApp = () => {
    let os = helpers.getMobileOperatingSystem();
    console.log("os:", os);
    let url = "";
    if (os == "Android") {
      url =
        "https://play.google.com/store/apps/details?id=com.app.themorningcontext";
    } else if (os == "iOS") {
      url = "https://apps.apple.com/in/app/the-morning-context/id1551672701";
    } else {
      console.log("OS not supported for dynamic linking");
    }
    window.open(url, "_blank");
  };

  render() {
    let darkMode = this.props.darkMode;
    return (
      <View style={styles.centeredView}>
        <Modal
          animationType="slide"
          transparent={true}
          visible={this.state.modalVisible}
        >
          <View
            style={{
              flex: 1,
              justifyContent: "flex-end",
              // bottom: 0,
              // position: "fixed",
              // width: "100%",
              // height: "100vh",
            }}
          >
            <View
              style={[
                {
                  minHeight: helpers.isDesktop() ? windowHeight * 0.6 : "auto",
                  marginTop: "auto",
                  backgroundColor: "#FFF",
                  justifyContent: helpers.isDesktop() ? "center" : "flex-start",
                  alignItems: "center",
                  zIndex: 9999,
                  paddingHorizontal: helpers.isDesktop() ? 56 : 16,
                  paddingTop: helpers.isDesktop() ? 56 : 48,
                  paddingBottom: helpers.isDesktop() ? 56 : 100,
                },
              ]}
            >
              {/* <View >
                                  <Text style={{
                                      fontSize: 15,
                                      color: 'black',
                                      fontWeight: 600,
                                      letterSpacing: '0.015em',
                                      textTransform: 'uppercase',
                                      paddingBottom: 24,
                                  }}>
                                      SPECIAL OFFER
                                  </Text>
                              </View> */}
              <View>
                <Text
                  style={{
                    fontSize: helpers.isDesktop()
                      ? "48px"
                      : this.props.postData?.story?.type == "non_privileged"
                        ? "27px"
                        : "22px",
                    lineHeight: helpers.isDesktop() ? "45px" : "25px",
                    color: "#000",
                    fontWeight: 700,
                    fontFamily: "PlayfairDisplay-Bold",
                    textAlign: "center",
                  }}
                >
                  {this.props.postData?.story?.type == "non_privileged"
                    ? "Unlock this story."
                    : "Unlock The Morning Context."}
                </Text>
              </View>
              <View>
                <Text
                  style={{
                    fontSize: helpers.isDesktop()
                      ? "48px"
                      : this.props.postData?.story?.type == "non_privileged"
                        ? "27px"
                        : "22px",
                    lineHeight: helpers.isDesktop() ? "45px" : "25px",
                    color: "#000",
                    fontWeight: 700,
                    fontFamily: "PlayfairDisplay-Bold",
                    paddingBottom: 16,
                    textAlign: "center",
                  }}
                >
                  {this.props.postData?.story?.type == "non_privileged"
                    ? "Get 100 FREE credits."
                    : `Just ${this.props.country?.code !== "IN" ? "$" : "INR "
                    }${this.props.country?.code == "IN" ? "267" : "9"
                    } a month.`}
                </Text>
              </View>
              <View style={{ marginBottom: helpers.isDesktop() ? 40 : 32 }}>
                <Text
                  style={{
                    fontSize: helpers.isDesktop() ? 18 : 18,
                    color: "#52524f",
                    lineHeight: 22,
                    marginBottom: 0,
                    fontFamily: FontFamily.regular,
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >
                  {this.props.postData?.story?.type == "non_privileged"
                    ? "Get the news that matters the most."
                    : "Get exclusive access to reporting, analysis and commentary you won’t find anywhere else."}
                </Text>
              </View>
              <View>
                <ButtonGradient
                  title={"Get Started"}
                  rootStyle={{
                    btnWrapper: [
                      button.primaryGradient,
                      {
                        width: "100%",
                        paddingHorizontal: "16px",
                        paddingTop: helpers.isDesktop() ? "16px" : "13px",
                        paddingBottom: helpers.isDesktop() ? "18px" : "13px",
                        // marginTop: helpers.isDesktop() ? 40 : 32,
                        height: "auto",
                        backgroundColor: "transparent",
                      },
                    ],
                    btnText: [
                      button.primaryGradientText,
                      {
                        fontSize: helpers.isDesktop() ? "27px" : "18px",
                        textTransform: "capitalize",
                        fontFamily: "PlayfairDisplay-Regular",
                      },
                    ],
                  }}
                  onClick={() => {
                    this.props.navigateToScreen("/pricing?header=true");
                  }}
                  fullWidth={false}
                  darkMode={darkMode}
                  leftAligned={true}
                  isNewGradiant={true}
                />
              </View>
              <View
                style={{
                  marginTop: helpers.isDesktop() ? 40 : 32,
                }}
              >
                {!this.props.isLoggedin ? (
                  <>
                    {helpers.isDesktop() ? (
                      <Text
                        style={{
                          fontSize: 18,
                          color: "#52524f",
                          lineHeight: 22,
                          fontFamily: "PlayfairDisplay-Regular",
                        }}
                      >
                        Already have an account?
                        <TouchableOpacity
                          onPress={() => this.props.goToLogin()}
                        >
                          <Text
                            style={{
                              fontWeight: 600,
                              fontFamily: "PlayfairDisplay-Bold",
                              marginLeft: 5,
                            }}
                          >
                            Log In
                          </Text>
                        </TouchableOpacity>
                      </Text>
                    ) : (
                      <View style={{ flexDirection: "row" }}>
                        <TouchableOpacity
                          onPress={() => this.props.goToLogin()}
                        >
                          <Text
                            style={{
                              fontSize: helpers.isDesktop() ? 18 : 16,
                              fontWeight: 600,
                              fontFamily: FontFamily.regular,
                            }}
                          >
                            Log In
                          </Text>
                        </TouchableOpacity>
                        <Text style={{ fontFamily: "PlayfairDisplay-Regular" }}>
                          &nbsp;or&nbsp;
                        </Text>
                        <TouchableOpacity onPress={() => this.openApp()}>
                          <Text
                            style={{
                              fontSize: helpers.isDesktop() ? 18 : 16,
                              fontWeight: 600,
                              fontFamily: FontFamily.regular,
                            }}
                          >
                            Open in app
                          </Text>
                        </TouchableOpacity>
                      </View>
                    )}
                  </>
                ) : null}
              </View>
              <TouchableOpacity
                style={styles.addButton}
                onPress={() => {
                  this.setModalVisible(!this.state.modalVisible);
                }}
              >
                <View
                  style={{
                    width: helpers.isDesktop() ? "15px" : "10px",
                    height: helpers.isDesktop() ? "15px" : "10px",
                  }}
                >
                  <CustomImage
                    resizeMode={"contain"}
                    source={close}
                    require={true}
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                    altText={"Have Only 5 Minutes"}
                  />
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#98B3B7",
    justifyContent: "center",
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerText: {
    color: "black",
    fontSize: 18,
    padding: 26,
  },
  noteHeader: {
    backgroundColor: "#42f5aa",
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
  },
  footer: {
    flex: 1,
    backgroundColor: "#ddd",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
  },
  textInput: {
    alignSelf: "stretch",
    color: "black",
    padding: 20,
    backgroundColor: "#ddd",
    borderTopWidth: 2,
    borderTopColor: "#ddd",
  },
  addButton: {
    position: "absolute",
    zIndex: 11,
    right: helpers.isDesktop() ? 20 : 10,
    top: helpers.isDesktop() ? 20 : 8,
    backgroundColor: "#98B3B7",
    width: helpers.isDesktop() ? 40 : 25,
    height: helpers.isDesktop() ? 40 : 25,
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    elevation: 8,
  },
  addButtonText: {
    color: "#fff",
    fontSize: helpers.isDesktop() ? 18 : 11,
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    flex: 1,
    justifyContent: "flex-end",
  },
  centeredView: {
    position: "absolute",
    top: 100,
  },
});

export default StoryModal;
